import * as yup from 'yup'

export const supplier = yup.object().shape({
  empresaId: yup.string().required('La empresa es obligatorio'),
  estado: yup.string().required('El estado es obligatorio'),
})
